import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    connect() {
        document.body.classList.add("overflow-hidden");
    }

    disconnect() {
        document.body.classList.remove("overflow-hidden");
    }

    close() {
        this.element.remove();
    }

    closeOnOverlay(event) {
        if (event.target === this.element) {
            this.close();
        }
    }
}
